(() => {
  if (window.TBFDiscount) return;
  const cache=new Map();
  const parallel=async(items,fn,concurrency=4)=>{
    const result=new Array(items.length);let cursor=0;
    await Promise.all(Array.from({length:Math.min(concurrency,items.length)},async()=>{
      while(cursor<items.length){const i=cursor++;result[i]=await fn(items[i],i);}
    }));return result;
  };
  const rank=(records,rules,min=0,max=Infinity)=>records.flatMap(p=>{
    const system=window.TBFSizeSystem(p.scale).key;
    const sizes=rules.get(system);
    if(rules.size&&!sizes)return [];
    const variants=p.variants.filter(v=>(!sizes||sizes.has(v[1]))&&v[2]>=min&&v[2]<=max);
    if(!variants.length)return [];
    const score=v=>v[3]>v[2]&&v[3]>0?(v[3]-v[2])/v[3]:0;
    variants.sort((a,b)=>score(b)-score(a)||a[2]-b[2]||String(a[0]).localeCompare(String(b[0])));
    return [{...p,variant:variants[0][0],score:score(variants[0]),price:variants[0][2]}];
  }).sort((a,b)=>b.score-a.score||a.price-b.price||a.id.localeCompare(b.id,undefined,{numeric:true}));
  window.TBFDiscount={rank,create(root,rules){
    if(new URL(location.href).searchParams.get('tbf_sort')!=='discount-descending')return null;
    const grid=root.querySelector('#product-grid'),pagination=root.querySelector('#AjaxinatePagination');
    if(!grid || !pagination)return null;
    const source=new URL(location.href);source.searchParams.delete('page');source.searchParams.delete('tbf_page');source.searchParams.delete('tbf_sort');source.searchParams.set('sort_by','created-descending');source.searchParams.set('filter.v.availability','1');
    let sorted=[],loaded=0;const cards=new Map();let controller=new AbortController();
    const status=document.createElement('p');status.className='tbf-discount-status';status.setAttribute('role','status');grid.before(status);
    root.closest('main')?.addEventListener('tbf:dispose',()=>controller.abort(),{once:true});
    const request=async url=>{const response=await fetch(url,{credentials:'same-origin',signal:controller.signal});if(!response.ok)throw Error('Unavailable');return new DOMParser().parseFromString(await response.text(),'text/html');};
    const indexPage=async page=>{const url=new URL(source);url.searchParams.set('section_id','tbf-discount-index');url.searchParams.set('page',page);const doc=await request(url);const node=doc.querySelector('[data-tbf-discount-index]');if(!node)throw Error('Missing index');return JSON.parse(node.textContent);};
    const updatePage=()=>{
      pagination.replaceChildren();
      if(loaded<sorted.length){const link=document.createElement('a');const url=new URL(location.href);url.searchParams.set('tbf_page',String(Math.floor(loaded/12)+1));link.href=url;link.textContent=root.dataset.loadMore;pagination.append(link);}
      const count=root.querySelector('[data-tbf-count]');if(count&&!root.dataset.tbfPendingMatches)count.textContent=root.dataset.finalLabel.replace('[count]',sorted.length);
    };
    const card=async record=>{
      const url=new URL(`/products/${record.handle}`,location.origin);url.searchParams.set('variant',record.variant);url.searchParams.set('section_id','tbf-discount-card');
      const doc=await request(url);const node=doc.querySelector('[data-tbf-product]');if(!node||node.dataset.tbfProduct!==record.id)throw Error('Missing card');
      node.dataset.tbfDiscount=String(record.score);return node;
    };
    const append=async()=>{
      const batch=sorted.slice(loaded,loaded+12);
      const nodes=await parallel(batch,async record=>{if(!cards.has(record.id))cards.set(record.id,await card(record));return cards.get(record.id);});
      if(!root.isConnected)return;
      grid.append(...nodes);loaded+=batch.length;updatePage();
    };
    return {async init(){
      grid.hidden=true;pagination.replaceChildren();status.hidden=false;
      const empty=root.querySelector('#ProductGridContainer .title');if(empty)empty.hidden=true;
      root.querySelectorAll('[data-tbf-empty-match]').forEach(node=>node.hidden=true);
      status.textContent=root.dataset.discountLoading.replace('[count]','0');
      try{
        let records;const key=source.href,existing=cache.get(key);
        if(existing&&Date.now()-existing.time<60000)records=existing.records;
        else{
          const first=await indexPage(1);
          if(first.total>25000)throw Error('Too many products');
          let checked=first.products.length;status.textContent=root.dataset.discountLoading.replace('[count]',checked);
          const rest=await parallel(Array.from({length:Math.max(0,first.pages-1)},(_,i)=>i+2),async page=>{const data=await indexPage(page);checked+=data.products.length;status.textContent=root.dataset.discountLoading.replace('[count]',checked);return data.products;});
          records=[...new Map([first.products,...rest].flat().map(p=>[p.id,p])).values()];
          if(records.length!==first.total)throw Error('Incomplete catalogue');
          if(cache.size>4)cache.delete(cache.keys().next().value);cache.set(key,{records,time:Date.now()});
        }
        const min=Number(source.searchParams.get('filter.v.price.gte')||0)*100;
        const max=source.searchParams.has('filter.v.price.lte')?Number(source.searchParams.get('filter.v.price.lte'))*100:Infinity;
        sorted=rank(records,rules,min,max);loaded=0;grid.replaceChildren();
        await append();grid.hidden=false;status.textContent=sorted.length?'':root.dataset.emptyMessage;status.hidden=sorted.length>0;return true;
      }catch(error){
        if(error.name==='AbortError')return false;
        root.dataset.tbfDiscountError = error.message;
        status.textContent=error.message==='Too many products'?root.dataset.discountLimit:root.dataset.discountError;
        const retry=document.createElement('button');retry.type='button';retry.textContent=root.dataset.retry;retry.addEventListener('click',()=>root.dispatchEvent(new Event('tbf:discount:retry')),{once:true});status.append(' ',retry);return false;
      }
    },append};
  }};
})();
